import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyCj3EoHcAgeXHu0DKebK3ctldW5Sn3G4Ek',
  authDomain: 'chromecast.smeegoon.com',
  projectId: 'smeegoon',
  storageBucket: 'smeegoon.firebasestorage.app',
  messagingSenderId: '756972553530',
  appId: '1:756972553530:web:391f3202311424b48e3c03',
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };

/*   
  static const FirebaseOptions web = FirebaseOptions(
    apiKey: 'AIzaSyCj3EoHcAgeXHu0DKebK3ctldW5Sn3G4Ek',
    appId: '1:756972553530:web:391f3202311424b48e3c03',
    messagingSenderId: '756972553530',
    projectId: 'smeegoon',
    authDomain: 'smeegoon.firebaseapp.com',
    storageBucket: 'smeegoon.firebasestorage.app',
    measurementId: 'G-Q6T654NR7D',
  );
  */